'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps", "className", "classes", "sx"];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { ComposerAttachButton } from '@mui/x-chat-headless';
import { styled, createUseThemeProps } from "../internals/zero-styled/index.mjs";
import { useChatComposerUtilityClasses } from "./chatComposerClasses.mjs";
import { mergeSlotProps } from "../internals/mergeSlotProps.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const useThemeProps = createUseThemeProps('MuiChatComposerAttachButton');
const ChatComposerAttachButtonStyled = styled('button', {
  name: 'MuiChatComposer',
  slot: 'AttachButton',
  overridesResolver: (_, styles) => styles.attachButton
})(({
  theme
}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 36,
  height: 36,
  border: 'none',
  borderRadius: '50%',
  backgroundColor: 'transparent',
  color: (theme.vars || theme).palette.text.secondary,
  cursor: 'pointer',
  flexShrink: 0,
  transition: theme.transitions.create(['background-color', 'color'], {
    duration: theme.transitions.duration.short
  }),
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none'
  },
  padding: 0,
  fontSize: '1.25rem',
  '&:hover': {
    backgroundColor: (theme.vars || theme).palette.action.hover,
    color: (theme.vars || theme).palette.text.primary
  },
  '&:focus-visible': {
    outline: `2px solid ${(theme.vars || theme).palette.primary.main}`,
    outlineOffset: 2
  },
  '&:disabled': {
    color: (theme.vars || theme).palette.action.disabled,
    cursor: 'not-allowed'
  },
  '& svg': {
    width: '1em',
    height: '1em',
    fontSize: 'inherit'
  }
}));
const ChatComposerAttachButton = /*#__PURE__*/React.forwardRef(function ChatComposerAttachButton(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiChatComposerAttachButton'
  });
  const {
      slots,
      slotProps,
      className,
      classes: classesProp,
      sx
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const classes = useChatComposerUtilityClasses(classesProp);
  return /*#__PURE__*/_jsx(ComposerAttachButton, _extends({
    ref: ref
  }, other, {
    slots: _extends({}, slots, {
      attachButton: slots?.attachButton ?? ChatComposerAttachButtonStyled
    }),
    slotProps: _extends({}, slotProps, {
      attachButton: mergeSlotProps({
        className: clsx(classes.attachButton, className),
        sx
      }, slotProps?.attachButton)
    })
  }));
});
if (process.env.NODE_ENV !== "production") ChatComposerAttachButton.displayName = "ChatComposerAttachButton";
process.env.NODE_ENV !== "production" ? ChatComposerAttachButton.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: PropTypes.object,
  className: PropTypes.string,
  slotProps: PropTypes.object,
  slots: PropTypes.object,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
export { ChatComposerAttachButton };